// The outcomes of journaling a URL action (useCollection.journalUrlAction).
//  ok:       durably recorded (written and read back)
//  full:     refused, the journal already holds URL_ACTION_CAP unsettled actions
//  unstored: no durable record (storage refused it, or not the writer tab)
export const JOURNAL = {
  ok: 'ok',
  full: 'full',
  unstored: 'unstored',
} as const

export type JournalResult = typeof JOURNAL[keyof typeof JOURNAL]
